/**
 * Converts size value (Integer or CSSDimension) to rem string
 * Each unit = 0.25rem (matching foundation spacing scale)
 */
export function toSizeValue(value: unknown): string {
  if (typeof value === 'number') {
    return `${value * 0.25}rem`;
  }
  return value as string;
}
